module.exports = __webpack_public_path__ + "static/media/undraw_add_document_0hek.9082c49f.svg";